import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../../SharedComponents/IconSvg";
import { Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import React from "react";

const ShowcaseSection = ({ showcaseList, xs }) => {
  return (
    <Row className="d-flex justify-content-center mx-2 mx-lg-0 mt-5">
      <Col
        xs={12}
        lg={11}
        className={"text-18 text-lg-24 align-content-center fw-medium pb-4  "}
        style={{
          border: "1px solid #B9D5F6",
          borderRadius: "16px",
          color: "#000",
        }}
      >
        <Row>
          {showcaseList.map((showcaseItem, index) => {
            return (
              <Col key={index} lg={4} xs={xs ? xs : 6} className={"text-center"}>
                <Row className={"justify-content-center"}>
                  <Col style={{ width: 164 }}>
                    <Row className={"justify-content-center mt-5 mb-4"}>
                      <Col xs={"auto"}>
                        <IconSvg icon={showcaseItem.icon} />
                      </Col>
                    </Row>
                    <Row className={"mx-0 mb-5 text-center justify-content-center"}>
                      <Col
                        style={{
                          maxWidth: 240,
                        }}
                      >
                        {showcaseItem.text}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
};
export default ShowcaseSection;
